// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2j0Oj","rootCenter":"LoadMoreObserver_rootCenter__3Cqtq","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__N16Oo"};